import api from './api';

const BASE_URL = '/api/sports-management';

export const activityLogService = {
    getLogs: (filters = {}) => {
        const params = {};
        if (filters.userId) params.userId = filters.userId;
        if (filters.startDate) params.startDate = filters.startDate;
        if (filters.endDate) params.endDate = filters.endDate;
        if (filters.action) params.action = filters.action;
        return api.get(`${BASE_URL}/activity-logs`, { params });
    }
};
